{
  "global": {
    "backToHome": "Retour à la page d'accueil",
    "errors": {
      "unhandledError": "Une erreur non gérée s'est produite",
      "serverError": "Une erreur est survenue. Veuillez réessayer ultérieurement.",
      "accessDenied": "Accès refusé"
    }
  },
  "header": {
    "logoAlt": "CIM Bank - Banque privée suisse",
    "btnLogout": "Déconnexion",
    "btnMessages": "Messages",
    "btnRegistrations": "Mes inscriptions"
  },
  "footer": {
    "copyright": "© CIM Banque SA - Genève, Lugano, Wollerau - Suisse",
    "contactFormLabel": "Formulaire de contact",
    "contactFormSubtitle": "Veuillez utiliser notre formulaire de contact pour entrer en contact avec l'un de nos spécialistes.",
    "relationshipManagerLabel": "Mon gestionnaire de relations",
    "contactHours": "Du lundi au vendredi, de 8h30 à 18h30",
    "contactPhone": "+41 (0)58 225 50 50"
  },
  "modal": {
    "confirmButton": "Ok",
    "cancelButton": "Annuler",
    "remark": "Remarque"
  },
  "attachment": {
    "fileNoName": "Fichier sans nom",
    "errors": {
      "noMultipleFilesAllowed": "Un seul fichier peut être téléchargé à la fois",
      "allowedTypes": "Seules les images ou PDF sont autorisés",
      "unhandledError": "Une erreur est survenue lors du téléchargement du fichier. Veuillez vérifier la taille du fichier (max 8MB) et réessayer ultérieurement."
    }
  },
  "gender": {
    "gender": "Genre",
    "male": "Homme",
    "female": "Femme",
    "genderError": "Le genre est obligatoire"
  },
  "maritalStatusEnum": {
    "single": "Célibataire",
    "married": "Marié(e)",
    "divorced": "Divorcé(e)",
    "widower": "Veuf/Veuve",
    "civilUnion": "Union civile"
  },
  "counterpartyOperationTypeEnum": {
    "import": "Importation",
    "export": "Exportation",
    "intermediation": "Intermédiation",
    "fees": "Frais",
    "logisticsAndTransport": "Logistique et transports",
    "other": "Autre"
  },
  "counterpartyCashFlowTypeEnum": {
    "incoming": "Entrant",
    "outgoing": "Sortant"
  },
  "signatureTypeEnum": {
    "signature": "Signature",
    "signatureIndividual": "Individuelle",
    "signatureCollective": "Collective",
    "none": "Aucune"
  },
  "validation": {
    "onlyChars": "Ce champ ne doit contenir que des caractères ou des chiffres"
  },
  "messages": {
    "messagesDialogTitle": "Messages",
    "messageBy": "Par {username}",
    "messageOn": "le {date}",
    "messageSeen": "Vu par {username} le {date}",
    "addMessage": "Saisissez un message...",
    "addAttachment": "Ajouter une pièce jointe",
    "submit": "Soumettre"
  },
  "login": {
    "email": "E-mail",
    "btnRequestAccess": "Obtenir un lien sécurisé",
    "openAccount": "Ouvrir un compte ?",
    "description": "Nous vous enverrons un e-mail avec un lien qui vous fournira un accès sécurisé à notre plateforme.",
    "successMessage": "Veuillez vérifier vos e-mails et vous connecter en utilisant le lien sécurisé.",
    "errors": {
      "invalidToken": "Le lien n'est pas valide. Veuillez saisir votre adresse e-mail et nous vous enverrons un e-mail avec un lien qui vous fournira un accès sécurisé à notre plateforme.",
      "genericError": "Une erreur est survenue. Veuillez réessayer ultérieurement.",
      "email": "L'e-mail est requis",
      "emailInvalid": "L'e-mail doit être valide",
      "noRecipientFound": "Cet e-mail n'a pas été trouvé"
    }
  },
  "open": {
    "btnBack": "Retour",
    "btnNext": "Suivant",
    "btnSubmit": "Soumettre",
    "yes": "Oui",
    "no": "Non",
    "tabs": {
      "accountType": "Type de compte",
      "individual": {
        "contactInformation": "Contact personnel",
        "additionalInformation": "Informations complémentaires",
        "confirmation": "Confirmation"
      },
      "company": {
        "companyInformation": "Votre entreprise",
        "contactInformation": "Informations personnelles",
        "additionalInformation": "Informations complémentaires",
        "confirmation": "Confirmation"
      }
    },
    "accountType": {
      "title": "Sélectionnez votre type de compte",
      "subtitle": "Veuillez sélectionner quel type de compte vous aimeriez ouvrir.",
      "optionIndividual": "Compte personnel",
      "optionIndividualInformation": "Frais d'ouverture de <span class=\"cim-pink\">90</span> CHF/EUR/USD",
      "optionCorporate": "Compte d'entreprise",
      "optionCorporateInformation": "Frais d'ouverture de <span class=\"cim-pink\">500</span> CHF/EUR/USD",
      "warningPotential": ""
    },
    "individual": {
      "contactInformation": {
        "title": "Veuillez saisir vos coordonnées personnelles et de contact",
        "firstName": "Prénom",
        "middleName": "Deuxième prénom",
        "lastName": "Nom de famille",
        "email": "E-mail",
        "repeatEmail": "Répétez votre e-mail",
        "mobilePhone": "Téléphone mobile",
        "repeatMobilePhone": "Répéter le téléphone mobile"
      },
      "additionalInformation": {
        "title": "Veuillez saisir quelques informations complémentaires",
        "birthDate": "Date de naissance",
        "cityOfBirth": "Ville de naissance",
        "countryOfBirth": "Pays de naissance",
        "countryOfResidence": "Pays de résidence",
        "nationality": "Nationalité",
        "preferredLanguage": "Langue préférée"
      },
      "confirmation": {
        "greetings": "Merci !",
        "messageInvited": "Nous vous avons envoyé un e-mail contenant des instructions supplémentaires pour compléter votre demande d'ouverture de compte. Veuillez suivre le lien dans l'e-mail pour vous connecter à MyCIM. Si vous ne l'avez pas, merci de vérifiez vos spams.",
        "message": "Un gestionnaire va prochainement vous contacter pour commencer le processus d'ouverture de compte."
      },
      "errors": {
        "firstName": "Le prénom est obligatoire",
        "lastName": "Le nom de famille est obligatoire",
        "email": "L'e-mail est obligatoire",
        "emailInvalid": "L'e-mail doit être valide",
        "emailsDifferent": "Les e-mails doivent correspondre",
        "mobilePhone": "Le téléphone mobile est obligatoire et doit être valide (ex: +41XXXXXXXXX)",
        "mobilePhonesDifferent": "Les téléphones mobiles doivent correspondre",
        "birthDate": "La date de naissance est obligatoire et doit être valide",
        "birthDateFuture": "La date de naissance ne peut pas être postérieure à aujourd'hui",
        "cityOfBirth": "La ville de naissance est obligatoire",
        "countryOfBirth": "Le pays de naissance est obligatoire",
        "countryOfResidence": "La ville de résidence est obligatoire",
        "nationality": "La nationalité est obligatoire",
        "preferredLanguage": "La langue préférée est obligatoire"
      }
    },
    "company": {
      "companyType": {
        "domiciliaryTitle": "Entreprise non opérationnelle",
        "domiciliarySubtitle": "Détention de participations ou d'actifs.",
        "operatingTitle": "Société d'exploitation",
        "operatingSubtitle": "Prestation de services ou conduite de commerce.",
        "otherTitle": "Autre",
        "otherSubtitle": "Fiducie, fondation ou association, insurance wrapper."
      },
      "roleInCompany": {
        "noRole": "Aucun rôle formel dans la structure",
        "beneficial": "Bénéficiaire effectif (UBO)",
        "shareholder": "Actionnaire",
        "signatory": "Signataire",
        "introducingPartner": "Partenaire introducteur",
        "director": "Directeur"
      },
      "companyInformation": {
        "title": "Sélectionnez votre type d'entreprise",
        "companyName": "Nom de l'entreprise",
        "companyTypeRemark": "Justification de l'entreprise non opérationnelle",
        "incorporationCountry": "Pays de constitution",
        "contactTheBank": "Merci de contacter la banque pour poursuivre votre procédure d'ouverture"
      },
      "contactInformation": {
        "title": "Veuillez saisir vos propres informations personnelles",
        "info": "Veuillez fournir vos coordonnées avec lesquelles nous pourrons vous répondre",
        "firstName": "Prénom",
        "lastName": "Nom de famille",
        "role": "Quel est votre rôle dans l'entreprise ?",
        "cimBanqueCustomer": "Êtes-vous client CIM Banque ?",
        "accountNumber": "Quel est votre numéro de compte ?",
        "howHeard": "Comment avez-vous entendu parler de CIM Banque ?"
      },
      "additionalInformation": {
        "title": "Veuillez saisir vos propres coordonnées de contact",
        "email": "E-mail",
        "repeatEmail": "Répétez votre e-mail",
        "mobilePhone": "Téléphone mobile",
        "repeatMobilePhone": "Répéter votre téléphone mobile",
        "preferredLanguage": "Langue préférée"
      },
      "confirmation": {
        "greetings": "Merci !",
        "messageInvited": "Nous vous avons envoyé un e-mail contenant des instructions supplémentaires pour compléter votre demande d'ouverture de compte. Veuillez suivre le lien dans l'e-mail pour vous connecter à MyCIM. Si vous ne l'avez pas, merci de vérifiez vos spams.",
        "message": "Un gestionnaire va prochainement vous contacter pour commencer le processus d'ouverture de compte."
      },
      "errors": {
        "companyName": "Le nom de l'entreprise est obligatoire",
        "incorporationCountry": "Le pays de constitution est obligatoire",
        "role": "Role is mandatory",
        "alreadyCustomer": "Ce champ est obligatoire",
        "accountNumber": "Le numéro de compte est obligatoire",
        "firstName": "Le prénom est obligatoire",
        "lastName": "Le nom de famille est obligatoire",
        "email": "L'e-mail est obligatoire",
        "emailInvalid": "L'e-mail doit être valide",
        "emailsDifferent": "Les e-mails doivent correspondre",
        "mobilePhone": "Le téléphone mobile est obligatoire et doit être valide (ex: +41XXXXXXXXX)",
        "mobilePhonesDifferent": "Les téléphones mobiles doivent correspondre",
        "preferredLanguage": "La langue préférée est obligatoire",
        "companyTypeRemark": "La justification est obligatoire"
      }
    }
  },
  "register": {
    "btnBack": "Retour",
    "btnPrevious": "Précédent",
    "btnCancel": "Annuler",
    "btnNext": "Suivant",
    "btnContinue": "Continuer",
    "btnSubmit": "Soumettre",
    "btnSave": "Sauvegarder",
    "yes": "Oui",
    "no": "Non",
    "tabs": {
      "individualAccountUsage": "But du compte",
      "individualInformation": "Informations personnelles",
      "familyAndJob": "Famille et profession",
      "contract": "Contrat",
      "yourDocuments": "Vos documents",
      "companyAccountUsage": "But du compte",
      "companyInformation": "Informations sur l'entreprise",
      "companyStructure": "Structure de l'entreprise",
      "companyTransaction": "Informations sur les transactions",
      "companyCounterparties": "Contreparties",
      "underReview": "En cours d'examen",
      "refused": "Refusé",
      "initialDeposit": "Dépôt initial"
    },
    "prospectSelection": {
      "title": "Inscriptions en attente",
      "continue": "Continuer",
      "openAnotherAccount": "Ouvrir un autre compte"
    },
    "individualAccountUsage": {
      "title": "Choisissez l'objet du compte pour {displayName}",
      "accountUsages": {
        "savingsAndInvestments": "Épargne et investissements",
        "currentAccount": "Compte courant",
        "other": "Autre, précisez"
      }
    },
    "companyAccountUsage": {
      "title": "Choisissez l'objet du compte pour {displayName}",
      "accountUsages": {
        "commercialActivity": "Activité commerciale",
        "savingsAndInvestments": "Épargne et investissements",
        "currentAccount": "Compte courant",
        "other": "Autre, précisez"
      }
    },
    "individualInformation": {
      "title": "Remplissez les données personnelles du compte pour {displayName}",
      "subtitle": "Cher {username}, nous avons besoin de vous pour répondre aux questions suivantes",
      "addressLine1": "Adresse",
      "zipCode": "Code postal",
      "city": "Ville",
      "residenceCountryIsoCode": "Pays de résidence",
      "passportNumber": "Numéro de passeport",
      "passportExpirationDate": "Date d'expiration du passeport",
      "taxationCountryIsoCode": "Pays d'imposition",
      "tinNumber": "Numéro NIF",
      "hasTinNumber": "Je n'ai pas de numéro NIF",
      "relationWithUSA": "Lien avec les États-Unis",
      "isLinkedToUnitedStates": "Êtes-vous américain ?",
      "hasUSPassportOrGreenCard": "Avez-vous un passeport américain ou une Green Card ?",
      "hasSpentSubstantialTimeInUS": "Avez-vous séjourné plus de 90 jours par an aux États-Unis ?",
      "isUSResidentForAnyOtherReason": "Possédez-vous un bien immobilier aux États-Unis ?",
      "errors": {
        "addressLine1": "L'adresse est obligatoire",
        "zipCode": "Le code postal est obligatoire",
        "city": "La ville est obligatoire",
        "passportNumber": "Le numéro de passeport est obligatoire",
        "passportExpirationDate": "La date d'expiration du passeport est obligatoire et doit être valide",
        "passportExpirationDateOutdated": "La date doit être supérieure à la date d'aujourd'hui",
        "residenceCountryIsoCode": "Le pays est obligatoire",
        "taxationCountryIsoCode": "Le pays d'imposition est obligatoire",
        "tinNumber": "Le numéro NIF est obligatoire",
        "isLinkedToUnitedStates": "Le champ en lien avec les États-Unis est obligatoire",
        "hasUSPassportOrGreenCard": "Veuillez sélectionner une valeur",
        "hasSpentSubstantialTimeInUS": "Veuillez sélectionner une valeur",
        "isUSResidentForAnyOtherReason": "Veuillez sélectionner une valeur"
      }
    },
    "individualFamily": {
      "family": "Famille de {displayName}",
      "maritalStatus": "État civil",
      "spouse": "Conjoint / Partenaire",
      "needJointAccount": "J'ai besoin d'un compte joint",
      "children": "Enfants",
      "addChild": "Ajouter un enfant",
      "job": "Emploi de {displayName}",
      "roleLabel": "Emploi / profession 1/2",
      "jobLabel": "Emploi / profession 2/2",
      "workplaceCountry": "Pays du lieu de travail",
      "firstName": "Prénom",
      "lastName": "Nom de famille (Nom de jeune fille)",
      "errors": {
        "maritalStatus": "L'état civil est obligatoire",
        "job": "L'activité est obligatoire",
        "workplaceCountryIsoCode": "Le lieu de travail est obligatoire",
        "partnerFirstName": "Le prénom est obligatoire",
        "partnerLastName": "Le nom de famille est obligatoire"
      }
    },
    "individualInProgressModal": {
      "title": "Merci pour vos informations",
      "subtitle": "Vos données ont été enregistrées avec succès",
      "message": "Veuillez vous assurer que toutes vos informations personnelles sont correctes avant de continuer, car vous ne pourrez pas les modifier une fois passé à l'étape suivante"
    },
    "individualContract": {
      "title": "Contrat, termes et conditions",
      "subtitle": "Cher {username}, vous êtes sur le point de signer votre contrat. Veuillez prendre le temps de le lire.",
      "openAndRead": "Ouvrir et lire la version préliminaire de mon contrat",
      "contractAgreement": "J'ai lu et j'accepte mon contrat",
      "termsAgreement": "J'ai lu et j'accepte les <a class=\"cim-link\" target=\"_blank\" href=\"https://assets.cimbanque.com/documents/06_general-terms-and-conditions-en.pdf\">termes et conditions</a> de CIM Banque",
      "feesAgreement": "J'ai lu et j'accepte les <a class=\"cim-link\" target=\"_blank\" href=\"https://www.cimbanque.com/fr/fees-for-private-accounts\">frais et commissions</a> de CIM Banque",
      "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "J'ai lu et j'accepte les <a class=\"cim-link\" target=\"_blank\" href=\"https://assets.cimbanque.com/documents/special_risks_security_trading.pdf\">risques liés au trading d'instruments financiers</a>",
      "errors": {
        "contractAgreement": "Ce champ est obligatoire",
        "termsAgreement": "Ce champ est obligatoire",
        "feesAgreement": "Ce champ est obligatoire",
        "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "Ce champ est obligatoire"
      }
    },
    "individualDocuments": {
      "title": "Télécharger les documents de {displayName}",
      "certificateOfResidence": "Certificat de résidence",
      "certificateOfResidenceSubtitle": "Glissez-déposez ou cliquez pour télécharger le <span class='document-subtitle-string'>Certificat de résidence*</span> pour ce titulaire",
      "passport": "Passeport",
      "passportSubtitle": "Glissez-déposez ou cliquez pour télécharger le <span class='document-subtitle-string'>Passeport</span> pour ce titulaire",
      "datedLess": "* Datés de moins de 12 mois et délivrés par une autorité gouvernementale compétente - Attention, les factures de services publics et les relevés bancaires ne sont plus acceptés",
      "errors": {
        "allowedTypes": "Seules les images ou PDF sont autorisés",
        "unhandledError": "Une erreur est survenue lors du téléchargement du fichier. Veuillez vérifier la taille du fichier (max 8MB) et réessayer ultérieurement."
      }
    },
    "companyInformation": {
      "title": "Remplissez les informations de votre entreprise pour {displayName}",
      "addressLine1": "Adresse",
      "addressLine2": "Adresse complémentaire",
      "zipCode": "Code postal",
      "city": "Ville",
      "residenceCountryIsoCode": "Pays",
      "website": "Site web",
      "shareCapital": "Capital social",
      "shareCapitalCurrencyIsoCode": "Devise",
      "dateOfIncorporation": "Date de constitution",
      "countryOfIncorporation": "Pays de constitution",
      "roleLabel": "Activité 1/2",
      "activityId": "Activité 2/2",
      "activityRemark": "Description d'activité",
      "hasBalanceSheetFinancialStatement": "L'entreprise a un bilan audité ?",
      "hasExternalAccounting": "L'entreprise dispose d'une comptabilité externe ?",
      "hasPhysicalOffice": "L'entreprise dispose de bureaux physiques en/au/aux {countryName} ?",
      "officeCountryIsoCode": "Pays où sont situé les bureaux",
      "numberOfEmployees": "Nombre d'employés dans les bureaux",
      "hasEmployeesInPlaceOfIncorporation": "L'entreprise compte des employés en/au/aux {countryName} ?",
      "hasDirectorInPlaceOfIncorporation": "La société a un directeur en/au/aux {countryName} ?",
      "holdAnOperatingCompany": "La société détient une société d'exploitation active ?",
      "hasReadAndAgreeWithTermsAndConditions": "J'ai lu et j'accepte les <a class=\"cim-link\" target=\"_blank\" href=\"https://assets.cimbanque.com/documents/06_general-terms-and-conditions-en.pdf\">termes et conditions</a> de CIM Banque",
      "hasReadAndAgreeWithFeesAndCommissions": "J'ai lu et j'accepte les <a class=\"cim-link\" target=\"_blank\" href=\"https://www.cimbanque.com/fees-for-company-accounts\">frais et commissions</a> de CIM Banque",
      "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "J'ai lu et j'accepte les <a class=\"cim-link\" target=\"_blank\" href=\"https://assets.cimbanque.com/documents/special_risks_security_trading.pdf\">risques liés au trading d'instruments financiers</a>",
      "errors": {
        "addressLine1": "L'adresse est obligatoire",
        "zipCode": "Le code postal est obligatoire",
        "city": "La ville est obligatoire",
        "residenceCountryIsoCode": "Le pays est obligatoire",
        "shareCapital": "Le capital social est obligatoire",
        "shareCapitalCurrencyIsoCode": "La devise est obligatoire",
        "dateOfIncorporation": "La date de constitution est obligatoire et doit être valide",
        "pastDateOfIncorporation": "La date de constitution doit être antérieure à aujourd'hui",
        "countryOfIncorporation": "Le pays de constitution est obligatoire",
        "officeCountryIsoCode": "Le pays où sont situé les bureaux est obligatoire",
        "numberOfEmployees": "Le nombre d'employés est obligatoire",
        "activityId": "L'activité est obligatoire",
        "activityRemark": "La description de l'activité est obligatoire si l'activité est Autre",
        "hasBalanceSheetFinancialStatement": "Ce champ est obligatoire",
        "hasExternalAccounting": "Ce champ est obligatoire",
        "hasPhysicalOffice": "Ce champ est obligatoire",
        "hasEmployeesInPlaceOfIncorporation": "Ce champ est obligatoire",
        "hasDirectorInPlaceOfIncorporation": "Ce champ est obligatoire",
        "hasReadAndAgreeWithTermsAndConditions": "Cette déclaration est obligatoire",
        "hasReadAndAgreeWithFeesAndCommissions": "Cette déclaration est obligatoire",
        "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "Cette déclaration est obligatoire",
        "holdAnOperatingCompany": "Ce champ est obligatoire"
      }
    },
    "companyStructure": {
      "signatory": "Signataire",
      "ubo": "Bénéficiaire ultime (UBO)",
      "ownershipTotalTitle": "Possession totale",
      "ownershipTotalWarning": "La somme des possessions doit être égale à 100%",
      "ownershipTitle": "Possession",
      "noUBO": "Aucun bénéficiaire ultime ajouté",
      "noSignatories": "Aucun signataire ajouté",
      "addNewEntity": "Ajouter un UBO ou un signataire",
      "incompleteRelatedEntites": "Au moins un bénéficiaire ultime ou signataire est incomplet",
      "title": {
        "companyStructure": "Décrivez la structure de l'entreprise",
        "relativeEntitySelection": "Personnes impliquées dans l'entreprise",
        "relativeEntityBeneficialOwnerAdd": "Ajouter un bénéficiaire ultime (UBO) pour {displayName}",
        "relativeEntityBeneficialOwnerEdit": "Editer un bénéficiaire ultime (UBO) pour {displayName}",
        "relativeEntitySignatoryAdd": "Ajouter un signataire pour {displayName}",
        "relativeEntitySignatoryEdit": "Modifier un signataire pour {displayName}",
        "relativeEntityPowerOfAttorneyAdd": "Ajouter un signataire pour {displayName}",
        "relativeEntityPowerOfAttorneyEdit": "Modifier un signataire pour {displayName}"
      },
      "deleteModal": {
        "UBOTitle": "Êtes-vous sûr de supprimer ce bénéficiaire ultime ?",
        "UBOSubtitle": "Vous êtes sur le point de supprimer ce bénéficiaire ultime : {entityName}",
        "signatoryTitle": "Êtes-vous sûr de supprimer ce signataire ?",
        "signatorySubtitle": "Vous êtes sur le point de supprimer ce signataire : {entityName}"
      }
    },
    "companyRelativeEntitySelection": {
      "addUbo": "Ajout d'un bénéficiaire ultime",
      "addUboInformation": "Ajout d'un bénéficiaire ultime (UBO)",
      "addSignatory": "Ajout d'un signataire",
      "addSignatoryInformation": "Ajout d'un signataire (Procuration)"
    },
    "companyRelativeEntity": {
      "ownership": "Propriétaire",
      "percentageOfOwnership": "Pourcentage de propriété",
      "personalInformation": "Informations personnelles",
      "firstName": "Prénom",
      "middleName": "Deuxième prénom",
      "lastName": "Nom de famille",
      "nationalityIsoCode": "Nationalité",
      "birthDate": "Date de naissance",
      "cityOfBirth": "Ville de naissance",
      "countryOfBirthIsoCode": "Pays de naissance",
      "contactInformation": "Coordonnées",
      "addressLine1": "Adresse",
      "addressLine2": "Adresse complémentaire",
      "zipCode": "Code postal",
      "city": "Ville",
      "residenceCountryIsoCode": "Pays de résidence",
      "mobilePhoneNumber": "Numéro de téléphone",
      "email": "E-mail",
      "passportInformation": "Informations de passeport",
      "passportNumber": "Numéro de passeport",
      "passportExpirationDate": "Date d'expiration du passeport",
      "jobInformation": "Informations d'activité",
      "role": "Activité 1/2",
      "activityId": "Activité 2/2",
      "workplaceCountryIsoCode": "Pays d'activité",
      "isPoliticallyExposed": "Le bénéficiaire ultime (UBO) est-il politiquement exposé ?",
      "isDirector": "Le directeur est-il au sein de la structure de l'entreprise ?",
      "taxationInformation": "Informations fiscales",
      "taxationCountryIsoCode": "Pays d'imposition",
      "tinNumber": "Numéro NIF",
      "hasTinNumber": "Je n'ai pas de numéro NIF",
      "isLinkedToUnitedStates": "Le bénéficiaire ultime a-t-il un lien avec les États-Unis ?",
      "hasUSPassportOrGreenCard": "Avez-vous un passeport américain ou une Green Card ?",
      "hasSpentSubstantialTimeInUS": "Avez-vous séjourné plus de 90 jours par an aux États-Unis ?",
      "isUSResidentForAnyOtherReason": "Possédez-vous un bien immobilier aux États-Unis ?",
      "errors": {
        "firstName": "Le prénom est obligatoire",
        "lastName": "Le nom de famille est obligatoire",
        "nationalityIsoCode": "La nationalité est obligatoire",
        "residenceCountryIsoCode": "Le pays est obligatoire",
        "workplaceCountryIsoCode": "Le lieu de travail est obligatoire",
        "birthDate": "La date de naissance est obligatoire et doit être valide",
        "birthDateFuture": "La date de naissance ne peut pas être postérieure à aujourd'hui",
        "cityOfBirth": "La ville de naissance est obligatoire",
        "countryOfBirthIsoCode": "Le pays de naissance est obligatoire",
        "addressLine1": "L'adresse est obligatoire",
        "zipCode": "Le code postal est obligatoire",
        "city": "La ville est obligatoire",
        "activityId": "L'activité est obligatoire",
        "taxationCountryIsoCode": "Le pays d'imposition est obligatoire",
        "isPoliticallyExposed": "Ce champ est obligatoire",
        "isDirector": "Ce champ est obligatoire",
        "percentageOfOwnership": "Le pourcentage de propriété est obligatoire",
        "percentageOfOwnershipInteger": "Le pourcentage de propriété doit être un nombre entier",
        "percentageOfOwnershipRange": "Le pourcentage de propriété doit être compris entre 0 et 100",
        "signature": "La signature est obligatoire",
        "passportNumber": "Le numéro de passeport est obligatoire",
        "passportExpirationDate": "La date d'expiration du passeport est obligatoire et doit être valide",
        "passportExpirationDateOutdated": "La date doit être supérieure à la date d'aujourd'hui",
        "isLinkedToUnitedStates": "Ce champ est obligatoire",
        "hasUSPassportOrGreenCard": "Ce champ est obligatoire",
        "hasSpentSubstantialTimeInUS": "Ce champ est obligatoire",
        "isUSResidentForAnyOtherReason": "Ce champ est obligatoire",
        "mobilePhoneNumber": "Le numéro de téléphone est obligatoire et doit être valide (ex: +41XXXXXXXXX)",
        "email": "L'e-mail est obligatoire",
        "emailValid": "L'email doit être valide",
        "tinNumber": "Le numéro NIF est obligatoire"
      }
    },
    "companyTransaction": {
      "title": "Transactions moyennes de l'entreprise par mois pour {displayName}",
      "subtitle": {
        "incomingTransfer": "Transferts entrants",
        "outgoingTransfer": "Transfers sortants"
      },
      "averageAmountOfIncomingTransfer": "Volume de transferts entrants",
      "averageAmountOfIncomingTransferCurrencyIsoCode": "Devise",
      "averageAmountOfOutgoingTransfer": "Volume de transferts sortants",
      "averageAmountOfOutgoingTransferCurrencyIsoCode": "Devise",
      "numberOfIncomingTransferPerMonth": "Nombre de transferts / mois",
      "numberOfOutgoingTransferPerMonth": "Nombre de transferts / mois",
      "errors": {
        "averageAmountOfIncomingTransfer": "Le volume de transferts entrants est obligatoire",
        "averageAmountOfIncomingTransferNumber": "Le volume de transferts entrants doit être un nombre",
        "averageAmountOfIncomingTransferCurrencyIsoCode": "La devise est obligatoire",
        "averageAmountOfOutgoingTransfer": "Le volume de transferts sortants est obligatoire",
        "averageAmountOfOutgoingTransferNumber": "Le volume de transferts sortants doit être un nombre",
        "averageAmountOfOutgoingTransferCurrencyIsoCode": "La devise est obligatoire",
        "numberOfIncomingTransferPerMonth": "Le nombre de transferts est obligatoire",
        "numberOfIncomingTransferPerMonthInteger": "Le nombre de transferts doit être un nombre",
        "numberOfOutgoingTransferPerMonth": "Le nombre de transferts est obligatoire",
        "numberOfOutgoingTransferPerMonthInteger": "Le nombre de transferts doit être un nombre"
      }
    },
    "companyCounterpartyList": {
      "transactions": "Transactions",
      "noResults": "Aucune transaction ajoutée. Veuillez ajouter toutes les contreparties impliquées si nécessaire.",
      "deleteModal": {
        "title": "Êtes-vous sûr de supprimer cette contrepartie ?",
        "subtitle": "Vous êtes sur le point de supprimer cette contrepartie : {entityName}"
      },
      "listHeaders": {
        "companyName": "Contrepartie",
        "nationalityIsoCode": "Nationalité",
        "funds": "Fonds",
        "goods": "Marchandises",
        "from": "Depuis",
        "to": "Vers",
        "hsCode": "HS Code",
        "operationType": "Type d'opération",
        "cashFlowType": "Type de flux financier",
        "yearlyValuationAmount": "Chiffre d'affaires annuel",
        "fundTransferFromCountryIsoCode": "Fonds depuis",
        "fundTransferToCountryIsoCode": "Fonds vers",
        "commodityFromCountryIsoCode": "Marchandises depuis",
        "commodityToCountryIsoCode": "Marchandises vers"
      }
    },
    "companyCounterpartyEdit": {
      "title": "Informations de la contrepartie",
      "companyName": "Nom de la contrepartie",
      "nationalityIsoCode": "Nationalité de la contrepartie",
      "fundTransferFromCountry": "Transfert des fonds depuis",
      "fundTransferFromSwitzerland": "CIM Banque",
      "fundTransferToCountry": "Transfert des fonds vers",
      "fundTransferToSwitzerland": "CIM Banque",
      "commodityFromCountryIsoCode": "Origine de la marchandise",
      "commodityToCountryIsoCode": "Destination de la marchandise",
      "productType": "Type de la marchandise",
      "hsCodeChapter": "HS Code Chapitre",
      "hsCode": "HS Code",
      "operationType": "Type d'opération",
      "cashFlowType": "Type de flux financier",
      "yearlyValuationAmount": "Chiffre d'affaires annuel",
      "yearlyValuationCurrencyIsoCode": "Devise",
      "bankName": "Nom de la banque",
      "errors": {
        "companyName": "Le nom de la contrepartie est obligatoire",
        "nationalityIsoCode": "La nationalité est obligatoire",
        "fundTransferFromCountryIsoCode": "L'origine des fonds est obligatoire",
        "fundTransferToCountryIsoCode": "La destination des fonds est obligatoire",
        "commodityFromCountryIsoCode": "L'origine de la marchandise est obligatoire",
        "commodityToCountryIsoCode": "La destination de la marchandise est obligatoire",
        "productType": "Le type de la marchandise est obligatoire",
        "operationType": "Le type d'opération est obligatoire",
        "cashFlowType": "Le type de flux financier est obligatoire",
        "yearlyValuationAmount": "Le chiffre d'affaires annuel est obligatoire",
        "yearlyValuationAmountNumber": "Le chiffre d'affaires annuel doit être un nombre",
        "yearlyValuationCurrencyIsoCode": "La devise est obligatoire",
        "bankName": "Le nom de la banque est obligatoire"
      }
    },
    "underReview": {
      "title": "Merci de votre intérêt pour CIM Banque.",
      "message": "Votre compte est en cours d'examen et nous vous contacterons sous peu. Si vous avez des questions concernant votre demande, n'hésitez pas à <a href='https://www.cimbanque.com/fr/the-bank/contact-us/' target='_blank'>nous contacter</a>."
    },
    "refused": {
      "title": "Merci de votre intérêt pour CIM Banque.",
      "message": "Cependant, nous sommes désolés de vous informer que nous ne pouvons pas poursuivre votre demande d'ouverture de compte."
    },
    "initialDeposit": {
      "title": "Votre dépôt initial",
      "activateAccount": "Pour activer votre compte et recevoir vos cartes de crédit, veuillez effectuer votre dépôt initial (Min. EUR/CHF/USD 5'000) depuis <u>votre compte BANCAIRE PERSONNEL ACTUEL<u> dans les 15 jours.",
      "activateAccountCorporate": "Pour activer votre compte et recevoir vos cartes de crédit, veuillez effectuer votre dépôt initial (Min. EUR/CHF/USD 10'000) depuis <u>votre compte BANCAIRE ACTUEL<u> dans les 15 jours.",
      "notice": "Veuillez noter que si vous n'approvisionnez pas votre compte dans les 15 jours, il sera automatiquement fermé."
    },
    "ibanTempo": {
      "name": "Nom",
      "tempIban": "Numéro IBAN temporaire",
      "swift": "Swift (BIC) Code",
      "bankAddress": "Adresse de la banque",
      "bank": {
        "name": "CIM BANQUE",
        "addressLine1": "RUE MERLE D'AUBIGNE 16",
        "addressLine2": "GENEVA 1211 - Switzerland",
        "swift": "CIMMCHGG"
      }
    }
  }
}
